/*
 * @Description: file content
 * @Author: Wang.Xichen
 * @Date: 2023-11-06 17:35:17
 * @LastEditors: Liuxia
 * @LastEditTime: 2024-09-19 10:35:03
 */
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/portal'
  },
  {
    path: '/portal',
    component: () => import(/* webpackChunkName: "portal" */ '../views/Portal.vue')
  },
  {
    path: '/portal-login',
    component: () => import(/* webpackChunkName: "portal" */ '../views/PortalLogin.vue')
  },
  {
    path: '/portal-home',
    redirect: '/portal'
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "project" */ '../views/Login.vue')
  },
  {
    path: '/litigationLogin',
    component: () => import(/* webpackChunkName: "project" */ '../views/LitigationLogin.vue')
  },
  {
    path: '/beautyLogin',
    component: () => import(/* webpackChunkName: "project" */ '../views/BeautyLogin.vue')
  },
  {
    path: '/workProLogin',
    component: () => import(/* webpackChunkName: "project" */ '../views/workProLogin.vue')
  },
  {
    path: '/user',
    component: () => import(/* webpackChunkName: "project" */ '../views/User.vue')
  },
  {
    path: '/mfa',
    component: () => import(/* webpackChunkName: "project" */ '../views/MFA.vue')
  },
  {
    path: '/smsLogin',
    component: () => import(/* webpackChunkName: "project" */ '../views/SMSLogin.vue')
  },
  {
    path: '/isaLogin',
    component: () => import(/* webpackChunkName: "project" */ '../views/ISALogin.vue')
  },
  {
    path: '/isaForgotPassword',
    component: () => import(/* webpackChunkName: "project" */ '../views/ISAForgotPassword.vue')
  },
  {
    path: '/forget-password',
    component: () => import(/* webpackChunkName: "project" */ '../views/ForgetPasswordPage.vue')
  },
  { path: '*', redirect: '/portal' },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path === '/portal-home') {
    next('/portal');
  } else {
    next();
  }
});

export default router;
